<template>
  <list-layout class="list-layout" :pageSize="pageSize" :currentPage="currentPage" :total="total"  @current-change="handleChange" @size-change="handleSizeChange">
    <span slot="title">代管库查询</span>
    <div class="tab" slot="btn_tabs">
      <el-tabs class="tab" :value="activename" @tab-click="btnTabClick">
        <el-tab-pane :disabled="IsLoading" label="代管总库存" name="all"></el-tab-pane>
        <el-tab-pane :disabled="IsLoading" label="租赁代管库" name="lease"></el-tab-pane>
        <el-tab-pane :disabled="IsLoading" label="自有代管库" name="self"></el-tab-pane>
      </el-tabs>
    </div>
    <el-form slot="search-bar" :inline="true">
      <el-form-item label="物料名称">
        <el-input class="form-input" v-model="Search.Product" placeholder="请输入物料名称／物料编码／客户物料名称／客户物料编码"></el-input>
      </el-form-item>
      <el-form-item label="区域">
        <el-select class="form-input" filterable v-model="Search.Region" placeholder="请选择或输入区域">
          <el-option v-for="item in Regions" :key="item.Id" :label="item.Name" :value="item.Id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="品牌">
        <el-select class="form-input" @change="changeBrand" clearable  filterable v-model="Search.BrandName" placeholder="请选择或输入品牌">
          <el-option v-for="item in BrandNames" :key="item.Id" :label="item.Name" :value="item.Name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="机型">
        <el-select v-model="Search.ProductModel" clearable filterable placeholder="请选择或输入机型">
          <el-option v-for="item in ProductModels" :key="item.Id" :label="item.Name" :value="item.Id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="模块">
        <el-select v-model="Search.ProductModule" clearable filterable placeholder="请选择或输入模块">
          <el-option v-for="item in ProductModules" :key="item.Id" :label="item.Name" :value="item.Id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="品项">
        <el-select v-model="Search.ProductCondition" clearable filterable placeholder="请选择或输入品项">
          <el-option v-for="item in ProductConditions" :key="item.Id" :label="item.Name" :value="item.Id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="IsLoading" @click="handleSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="table_area" slot="table_area">
      <div class="order-box">
        <el-button class="add-btn" type="primary" @click.native="toShipOrder()" v-if="activename != 'all'" style="margin-left:10px;">发货通知单
          <span v-if="this.shipbox.length != 0 ">{{this.shipbox.length}}</span>
        </el-button>
        <el-button class="add-btn add-btn1" @click.native="toDispatch()" style="margin-left:10px;" v-if="activename != 'all'">调度申请单
          <span v-if="this.managedbox.length != 0 ">{{this.managedbox.length}}</span>
        </el-button>
        <el-button class="add-btn" type="primary" @click.native="toTrustapply()" v-if="activename == 'self' && activename != 'all'">委托申请单
          <span v-if="this.trustbox.length != 0 ">{{this.trustbox.length}}</span>
        </el-button>
      </div>
      <table>
        <thead>
          <tr>
            <td>物料名称／编码</td>
            <td>客户物料名称／编码</td>
            <td>品项</td>
            <td>品牌</td>
            <td>机型</td>
            <td>模块</td>
            <td>库存数量</td>
            <td>区域</td>
            <td>操作</td>
          </tr>
        </thead>
        <tbody v-loading="IsLoading" element-loading-text="加载中">
          <tr v-for="item in tableData">
            <td width="230">
              {{item.ProductName}}<br>物料编码： {{item.ProductCode}}
            </td>
            <td width="230">{{item.CustomerProductName}}<br>物料编码： {{item.CustomerProductCode}}</td>
            <td width="100">
              <el-tag :type="item.ConditionName | ConditionColor">{{item.ConditionName}}</el-tag>
            </td>
            <td width="100">{{item.ProductBrandName}}</td>
            <td width="100">{{item.ProductModelName}}</td>
            <td width="100">{{item.ProductModuleName}}</td>
            <td width="80">{{item.Quantity}}</td>
            <td width="80">{{item.RegionName}}</td>
            <td width="300" v-if="activename != 'all'">
              <el-button type="primary" size="mini" @click.native="todetail(item)">查看</el-button>
              <div class="inline_box" v-if="activename == 'self'">
                <el-button type="primary" size="mini" @click.native="addmanaged(item)" style="margin-left:0px;" v-if="ifAddManaged(item) && item.Quantity > 0">加入委托</el-button>
                <el-button type="primary" size="mini" @click.native="cancelmanaged(item)" style="margin-left:0px;" v-else-if="!ifAddManaged(item) || item.Quantity > 0">取消加入委托</el-button>
              </div>
              <div class="inline_box">
                <el-button type="primary" size="mini" style="margin-bottom: 5px;" @click.native="adddispatch(item)" v-if="ifAddDispatch(item) && item.Quantity > 0">加入调度</el-button>
                <el-button type="primary" size="mini" style="margin-bottom: 5px;" @click.native="canceldispatch(item)" v-else-if="!ifAddDispatch(item) || item.Quantity > 0">取消加入调度</el-button>
              </div>
              <br v-if="activename != 'lease'">
              <div class="inline_box">
                <el-button type="primary" size="mini" @click.native="addship(item)" style="margin-left:0px;" v-if="ifAddShip(item) && item.Quantity > 0">加入发货</el-button>
                <el-button type="primary" size="mini" @click.native="cancelShip(item)" style="margin-left:0px;" v-else-if="!ifAddShip(item) || item.Quantity > 0">取消加入发货</el-button>
              </div>
              <el-button type="primary" size="mini" @click.native="setLimit(item)">上下限设置</el-button>
            </td>
            <td width="200" v-else>
              <el-button type="primary" size="mini" @click.native="todetail(item)">查看</el-button>
              <el-button type="primary" size="mini" @click.native="setLimit(item)">上下限设置</el-button>
            </td>
          </tr>
        </tbody>
      </table>
      <el-dialog title="上下限设置" size="small" class="pop-box" v-model="setLimitFormVisible">
        <!--         <el-form ref="form"  label-width="80px" style="border:none;">
                                <el-form-item label="仓库">
                                  <el-select v-model="setwarehouseId"  placeholder="请选择仓库(必填)" style="width:240px;">
                                    <el-option
                                      v-for="item in Regions"
                                      :key="item.Code"
                                      :label="item.Name"
                                      :value="item.Code">
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-form> -->
        <el-form>
          <div class="form-item">
            <!--             <el-form-item label="当前上限" :label-width="formLabelWidth">
                                    {{uplimitnumber}}件
                                  </el-form-item> -->
            <el-form-item label="设置上限" :label-width="formLabelWidth">
              <el-input type="number" v-model.number="uplimit" placeholder="请输入"  auto-complete="off"></el-input>
            </el-form-item>
          </div>
          <div class="form-item">
            <!--             <el-form-item label="当前下限" :label-width="formLabelWidth">
                                    {{downlimitnumber}}件
                                  </el-form-item> -->
            <el-form-item label="设置下限" :label-width="formLabelWidth">
              <el-input type="number" v-model.number="downlimit" placeholder="请输入" min="0" auto-complete="off"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="setLimitFormVisible = false">取 消</el-button>
          <el-button type="primary" @click.native="suresetLimit()">完 成</el-button>
        </div>
      </el-dialog>
    </div>
    <!--     <el-pagination
                            slot="pagination"
                            class="text-right"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="currentPage"
                            :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                          </el-pagination> -->

  </list-layout>
</template>

<script>
import ListLayout from '@/components/pages/Repair/ListLayout'
import o from '@/odata'
export default {
  data() {
    return {
      Search: {
        Product: null,
        BrandName: null,
        ProductModel: null,
        ProductModule: null,
        Region: null,
        ProductCondition: null,
      },
      IsLoading: false,
      formLabelWidth: '80px',
      setwarehouseId: '',
      downlimitnumber: '-',
      uplimitnumber: '-',
      downlimit: '',
      uplimit: '',
      setLimitFormVisible: false,
      shipbox: [],
      managedbox: [],
      BrandNames: [],
      ProductModules: [],
      ProductConditions: [],
      trustbox: [],
      orderUrl: '',
      OriginalOrderTypes: [
        { label: '入库单', value: 'InStockPicking' },
        { label: '租赁单', value: 'RentalOrder' },
        { label: '发货单', value: 'OutStockPicking' },
        { label: '内部调拨单', value: 'InternalStockPicking' },
        { label: '物流单', value: 'DeliveryOrder' },
        { label: '备用件退货单', value: 'DeliveryBackupReturn' },
        { label: '质检单', value: 'QcOrder' },
        { label: '租赁退货单', value: 'RentalReturnOrder' },
        { label: '租赁换货单', value: 'RentalExchangeOrder' },
        { label: '租赁维修单', value: 'RentalRepairOrder' },
        { label: '盘点单', value: 'InventoryOrder' },
        { label: '维修订单', value: 'RepairOrder' },
        { label: '维修单', value: 'RepairWorkOrder' },
        { label: '委外维修单', value: 'ExternalRepairWorkOrder' },
      ],
      activename: 'all',
      warehouseDate: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      Regions: [],
      ProductModels: [],
      RepairTypes: [
        { label: '租赁维修', value: 'rental' },
        { label: '委托维修', value: 'delegated' },
        { label: '代管维修', value: 'managed' },
        { label: '拆件维修', value: 'parts' },
      ],
      tableData: [],
      ProductId: null,
      ConditionId: null,
      sorts: ['日立', 'NCR', '迪堡', 'WINCOR', '运通', '御银', '富士通', '怡化', 'OKI', '东信', '恒银', '晓星', '新达通', '科堡', 'LG', 'NMD', '其他品牌'],  // 品牌用来排序的数组
    }
  },
  methods: {
    // 当选择品牌后根据品牌名对机型进行二级联动
    changeBrand: function(brandName) {
      // 如果有选中品牌则给初始化机型方法传入品牌名字参数，没有则重新初始化
      if (brandName) {
        this.initProductModel(brandName)
      } else {
        this.initProductModel()
      }
    },
    suresetLimit: function() {
      // if (this.setwarehouseId) {
      if (this.downlimit < 0 || this.uplimit < 0) {
        this.$message({
          message: '不能为负数',
          type: 'warning',
        })
      } else {
        if (this.uplimit < this.downlimit) {
          this.$message({
            message: '上限不能小于下限',
            type: 'warning',
          })
        } else {
          this.IsLoading = true
          const OrderPoint = o('CustomerOrderPoint')
          const form = {
            // WarehouseId: this.setwarehouseId,
            // ApplyTo: 'condition',
            ProductId: this.ProductId,
            ConditionId: this.ConditionId,
            MinQuantity: this.downlimit,
            MaxQuantity: this.uplimit,
          }
          OrderPoint.get().then((data) => {
            console.log(data)
          })
          OrderPoint.post(form).save().then((response) => {
            this.IsLoading = false
            this.$message({
              message: '提交成功',
              type: 'success',
            })
            this.setLimitFormVisible = false
          }).catch((response) => {
            this.IsLoading = false
          })
        }
      }
      // } else {
      //   return this.$alert('请选择仓库!')
      // }
    },
    setLimit: function(item) {
      const OrderPoint = o('CustomerOrderPoint').filter('(ConditionId eq ' + item.ConditionId + ') and (ProductId eq ' + item.ProductId + ')')
      OrderPoint.get().then((data) => {
        if (data.data.length > 0) {
          this.downlimit = data.data[0].MinQuantity
          this.uplimit = data.data[0].MaxQuantity
        } else {
          this.downlimit = ''
          this.uplimit = ''
        }
        console.log(data.data)
      })
      this.ConditionId = ''
      this.ProductId = ''
      this.ProductId = item.ProductId
      this.ConditionId = item.ConditionId
      this.setLimitFormVisible = true
    },
    toDispatch: function() {
      if (this.managedbox.length > 0) {
        this.$router.push('/managed_apply')
      } else {
        this.$message({
          message: '请添加物料！',
          type: 'info',
        })
      }
    },
    toTrustapply: function() {
      if (this.trustbox.length > 0) {
        this.$router.push('/trust_apply')
      } else {
        this.$message({
          message: '请添加物料！',
          type: 'info',
        })
      }
    },
    addmanaged: function(item) {
      this.trustbox.push(item)
      window.localStorage.setItem('trustbox', JSON.stringify(this.trustbox))
    },
    cancelmanaged: function(item) {
      let indexs = ''
      for (var a = 0; a < this.trustbox.length; a++) {
        if ((this.trustbox[a].ConditionId === item.ConditionId) && (this.trustbox[a].ProductId === item.ProductId)) {
          indexs = a
        }
      }
      this.trustbox.splice(indexs, 1)
      window.localStorage.setItem('trustbox', JSON.stringify(this.trustbox))
    },
    ifAddManaged: function(item) {
      let ifVal = true
      if (this.trustbox.length > 0) {
        for (var a = 0; a < this.trustbox.length; a++) {
          if ((this.trustbox[a].ConditionId === item.ConditionId) && (this.trustbox[a].ProductId === item.ProductId)) {
            ifVal = false
          }
        }
      }
      return ifVal
    },
    addship: function(item) {
      if (this.activename === 'lease') {
        item.type = 'rent'
      } else {
        item.type = 'manage'
      }
      this.shipbox.push(item)
      window.localStorage.setItem('shipbox', JSON.stringify(this.shipbox))
    },
    cancelShip: function(item) {
      let indexs = ''
      for (var a = 0; a < this.shipbox.length; a++) {
        if ((this.shipbox[a].ConditionId === item.ConditionId) && (this.shipbox[a].ProductId === item.ProductId)) {
          indexs = a
        }
      }
      this.shipbox.splice(indexs, 1)
      window.localStorage.setItem('shipbox', JSON.stringify(this.shipbox))
    },
    ifAddShip: function(item) {
      let ifVal = true
      if (this.shipbox.length > 0) {
        for (var a = 0; a < this.shipbox.length; a++) {
          if ((this.shipbox[a].ConditionId === item.ConditionId) && (this.shipbox[a].ProductId === item.ProductId)) {
            ifVal = false
          }
        }
      }
      return ifVal
    },
    adddispatch: function(item) {
      this.managedbox.push(item)
      window.localStorage.setItem('managedbox', JSON.stringify(this.managedbox))
    },
    canceldispatch: function(item) {
      let indexs = ''
      for (var a = 0; a < this.managedbox.length; a++) {
        if ((this.managedbox[a].ConditionId === item.ConditionId) && (this.managedbox[a].ProductId === item.ProductId)) {
          indexs = a
        }
      }
      this.managedbox.splice(indexs, 1)
      window.localStorage.setItem('managedbox', JSON.stringify(this.managedbox))
    },
    ifAddDispatch: function(item) {
      let ifVal = true
      if (this.managedbox.length > 0) {
        for (var a = 0; a < this.managedbox.length; a++) {
          if ((this.managedbox[a].ConditionId === item.ConditionId) && (this.managedbox[a].ProductId === item.ProductId)) {
            ifVal = false
          }
        }
      }
      return ifVal
    },
    toShipOrder: function() {
      if (this.shipbox.length > 0) {
        this.$router.push('/newship')
      } else {
        this.$message({
          message: '请添加物料！',
          type: 'info',
        })
      }
    },
    todetail: function(item) {
      if (this.activename === 'lease') {
        this.$router.push('/managedlease/' + item.ConditionId + '&' + item.ProductId)
      } else if (this.activename === 'all') {
        this.$router.push('/managedall/' + item.ConditionId + '&' + item.ProductId)
      } else {
        this.$router.push('/managedself/' + item.ConditionId + '&' + item.ProductId)
      }
    },
    handleSearch() {
      this.IsLoading = true
      let com = ''
      // 获取其他页面跳转至的模块
      this.orderUrl = window.localStorage.getItem('orderUrl')
      if (this.orderUrl) {
        if (this.orderUrl === 'trustapply') {
          this.activename = 'self'
        } else if (this.orderUrl === 'shipapply') {
          this.activename = 'lease'
        } else if (this.orderUrl === 'entrustOrder') {
          this.activename = 'self'
        }
        window.localStorage.setItem('orderUrl', '')
      }
      if (this.activename === 'all') {
        com += '?lotType=all'
      } else if (this.activename === 'lease') {
        com += '?lotType=rental'
      } else if (this.activename === 'self') {
        com += '?lotType=private'
      }
      let URL = 'CustomerManagedProductQuantity' + com
      const Services = o(URL)
      let filters = []
      if (this.Search.ProductModel) {
        filters.push(`ProductModelId eq ${this.Search.ProductModel}`)
      }
      if (this.Search.ProductModule) {
        filters.push(`ProductModuleId eq ${this.Search.ProductModule}`)
      }
      if (this.Search.BrandName) {
        filters.push(`ProductBrandName eq '${this.Search.BrandName}'`)
      }
      if (this.Search.ProductCondition) {
        filters.push(`ConditionId eq ${this.Search.ProductCondition}`)
      }
      if (this.Search.Region) {
        filters.push(`RegionId eq ${this.Search.Region}`)
      }
      if (this.Search.Product) {
        filters.push(`contains(ProductName, '${this.Search.Product.replace(/(^\s*)|(\s*$)/g, '')}') or contains(ProductCode, '${this.Search.Product.replace(/(^\s*)|(\s*$)/g, '')}')`)
        // filters.push(`(
        //   Lines/any(p:contains(p/Lot/Product/Name, '${this.Search.Product}'))
        //   or
        //   Lines/any(p:contains(p/Lot/Product/Code, '${this.Search.Product}'))
        // )`)
      }
      // 读取首页库存查询带过来的物料名称、编码【modifyby:zdx modifyon:2017-10-16】
      let pnames = this.$route.query.product
      if (pnames && pnames.length > 0) {
        let pnamearr = pnames.split(',')
        let _product = '('
        for (let i = 0; i < pnamearr.length; i++) {
          if (pnamearr[i].length > 0) {
            _product += `contains(ProductName,'${pnamearr[i]}')
              or
              contains(ProductCode, '${pnamearr[i]}')`
            if (i < pnamearr.length - 1) {
              _product += ' or '
            }
            // filters.push(`contains(ProductName,'${pnamearr[i]}')
            //   or
            //   contains(ProductCode, '${pnamearr[i]}')
            // `)
          }
        }
        _product += ')'
        console.log(_product)
        filters.push(_product)
      }
      // if (this.warehouseDate) {
      //   const startDate = this.$moment(this.warehouseDate[0]).utc().add(1, 'd').set({hour: 0, minute: 0, second: 0}).format()
      //   const endDate = this.$moment(this.warehouseDate[1]).utc().add(2, 'd').set({hour: 0, minute: 0, second: 0}).add(-1, 's').format()
      //   filters.push(`(OrderDate ge ${startDate} and OrderDate le ${endDate})`)
      // }
      if (filters.length > 0) {
        Services.filter(filters.join(' and '))
      }
      Services.inlineCount()
      Services.skip((this.currentPage - 1) * this.pageSize)
      Services.top(this.pageSize)
      // Services.orderBy('OrderDate', 'desc')
      Services.get().then(({ data, inlinecount }) => {
        this.IsLoading = false
        this.tableData = data
        this.total = inlinecount
        var a = []
        var b = []
        var c = []
        a = JSON.parse(window.localStorage.getItem('shipbox'))
        b = JSON.parse(window.localStorage.getItem('trustbox'))
        c = JSON.parse(window.localStorage.getItem('managedbox'))
        if (a == null) {
          window.localStorage.setItem('shipbox', JSON.stringify(this.shipbox))
        } else {
          this.shipbox = JSON.parse(window.localStorage.getItem('shipbox'))
        }
        if (b == null) {
          window.localStorage.setItem('trustbox', JSON.stringify(this.trustbox))
        } else {
          this.trustbox = JSON.parse(window.localStorage.getItem('trustbox'))
        }
        if (c == null) {
          window.localStorage.setItem('managedbox', JSON.stringify(this.managedbox))
        } else {
          this.managedbox = JSON.parse(window.localStorage.getItem('managedbox'))
        }
      }).fail((error) => {
        this.IsLoading = false
        this.$alert('数据加载失败:' + error.message)
      })
    },
    initReion: function() {
      const Region = o('Region')
      Region.get().then(({ data, inlinecount }) => {
        this.Regions = data
      }).fail((error) => {
        this.$alert('区域加载失败:' + error.message)
      })
    },
    initBrandNames: function() {
      const BrandName = o('ProductBrand')
      BrandName.get().then((data) => {
        // 按顺序遍历品牌排序名数组
        this.sorts.forEach(function(item) {
          // 遍历返回的品牌的集合，找到了遍历的品牌则插入到品牌集合中
          data.data.forEach(function(item2, index) {
            if (item2.Name === item) {
              this.BrandNames.push(item2)
              // 添加进集合后移除掉已经添加的品牌
              data.data.splice(index, 1)
            }
          }, this)
        }, this)
        // 把除'其他'品牌加进去
        // data.data.forEach(function(item, index) {
        //   if (!item.Name.indexOf('其他') > 0) {
        //     this.BrandNames.push(item)
        //     data.data.splice(index, 1)
        //   }
        // }, this)
        // // 最后加入其他品牌
        // data.data.forEach(function(item, index) {
        //   this.BrandNames.push(item)
        // }, this)
      }).fail((error) => {
        this.$alert('品牌加载失败:' + error.message)
      })
    },
    initProductModel: function(brandName) {
      this.ProductModels = []
      let ProductModel = o('ProductModel')
      if (brandName) {
        ProductModel.filter(`contains(Name, '${brandName}')`)
      }
      ProductModel.get().then((data) => {
        // 当有品牌名传入则进行联动排序
        if (brandName) {
          // 根据查询到的排序级别排序.从1开始,找到对应的级别的机型push集合中。遍历结束后push剩下的机型
          const count = data.data.length
          for (let i = 1; i <= count; i++) {
            // 找到对应的排序级别机型
            const insertItem = data.data.find((_) => _.Sort === i)
            // 如果没有该排序级别则不添加
            if (insertItem) {
              this.ProductModels.push(insertItem)
              // 获取到该机型在原数组中的下标，根据下标移除
              const removeIndex = data.data.findIndex(_ => _.Code === insertItem.Code)
              data.data.splice(removeIndex, 1)
            }
          }
          // 添加剩下的机型
          // data.data.forEach(function(item, index) {
          //   this.ProductModels.push(item)
          // }, this)
        } else {
          this.ProductModels = data.data
        }
      }).fail((error) => {
        this.$alert('机型加载失败:' + error.message)
      })
    },
    initProductModule: function() {
      const ProductModule = o('ProductModule')
      ProductModule.get().then((data) => {
        this.ProductModules = data.data
      }).fail((error) => {
        this.$alert('模块加载失败:' + error.message)
      })
    },
    initProductCondition: function() {
      const Inventory = o('ProductCondition')
      Inventory.get().then((data) => {
        this.ProductConditions = data.data
      }).catch((data) => { })
    },
    btnTabClick: function({ name }) {
      this.activename = name
      this.handleSearch()
    },
    handleChange(page) {
      this.currentPage = page
      this.handleSearch()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.handleSearch()
    },
  },
  components: {
    ListLayout,
  },
  created() {
    this.handleSearch()
    this.initProductCondition()
    this.initReion()
    this.initBrandNames()
    this.initProductModel()
    this.initProductModule()
  },
}
</script>

<style lang="less" scoped>
.inline_box {
  display: inline-block;
}

.form-input {
  width: 260px;
}

.list-layout .complex-table .sub-row-table .sub-body .text-center {
  border-right: 1px solid #dfe6ec;
  border-bottom: 1px solid #dfe6ec;
}

.main-content {
  .tab {
    .el-tabs__active-bar {
      background-color: rgba(0, 0, 0, 0);
    }
  }
}

.add-btn {
  font-size: 12px;
  border-radius: 4px;
  float: right;
  margin-bottom: 20px;
  margin-left: 30px;
  border: none;
  span {
    color: #2283CA;
    font-size: 10px;
    width: 12px;
    height: 12px;
    background-color: #fff;
    margin-left: 5px;
    border-radius: 50%;
  }
}
.add-btn1 {
  font-size: 12px;
  color: #FFFFFF;
  background: #e88603;
  border-radius: 4px;
  float: right;
  margin-bottom: 20px;
  margin-left: 10px;
  border: none;
  span {
    color: #2283CA;
    font-size: 10px;
    width: 12px;
    height: 12px;
    background-color: #fff;
    margin-left: 5px;
    border-radius: 50%;
  }
}
.add-btn1:hover,
.add-btn1:focus {
  color: #FFFFFF;
  background: #eaaf22;
}
</style>



// WEBPACK FOOTER //
// ManagedListPage.vue?1a42bfb2